/*
 * Immediate click feedback for the checkout buttons (side-cart drawer + cart page).
 *
 * Checkout is a full-page navigation to Shopify's checkout, so the loading state
 * naturally persists until the page unloads. This:
 *   - swaps the label to the "Taking you to checkout…" text (Theme settings),
 *   - shows a spinner and marks the button aria-busy,
 *   - blocks a second click from submitting the form again,
 *   - restores the button after 8s as a safety net if navigation never happens.
 *
 * Delegated on document so it keeps working after the cart drawer re-renders.
 */
(function () {
  var SELECTOR = 'button[name="checkout"]';
  var SAFETY_RESTORE_MS = 8000;

  function announce(text) {
    var region = document.getElementById('CheckoutLoadingLiveRegion');
    if (!region) {
      region = document.createElement('div');
      region.id = 'CheckoutLoadingLiveRegion';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('role', 'status');
      region.className = 'visually-hidden';
      document.body.appendChild(region);
    }
    region.textContent = text;
  }

  function restore(button) {
    if (button.dataset.submitting !== 'true') return;
    delete button.dataset.submitting;
    button.removeAttribute('aria-busy');
    button.classList.remove('loading', 'button--show-loading-text');
    var label = button.querySelector('span');
    if (label && button.dataset.originalLabel != null) {
      label.textContent = button.dataset.originalLabel;
    }
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  function onClick(event) {
    var button = event.target.closest(SELECTOR);
    if (!button) return;

    // Guard against a second click re-submitting while we navigate.
    if (button.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }
    if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;

    button.dataset.submitting = 'true';
    button.setAttribute('aria-busy', 'true');

    var label = button.querySelector('span');
    var loadingText = button.dataset.loadingText;
    if (label && loadingText) {
      button.dataset.originalLabel = label.textContent;
      label.textContent = loadingText;
      button.classList.add('button--show-loading-text');
      announce(loadingText);
    }

    button.classList.add('loading');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    // Do NOT preventDefault / disable — let the native form submission proceed.
    window.setTimeout(function () {
      restore(button);
    }, SAFETY_RESTORE_MS);
  }

  document.addEventListener('click', onClick, true);
})();
